//@flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// Components
import InputWrapper from '../InputWrapper';

// Types
type Props = {
  name: string,
  className?: string,
  formikProps: FormikProps,
};

/**
 * @visibleName Text
 */
const InputText = ({ className, ...props }: Props) => (
  <InputWrapper
    {...props}
    type="text"
    className={classnames('input-text', className)}
  />
);

export default InputText;
